import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

/**
 * DragDrop context wrapper, so that you can wrap anything and get the DragDropContext.
 * Needs to be a non functional component because of DragDropContext.
 */
class DragDropContextWrapper extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };
    render() {
        return this.props.children;
    }
}

export default DragDropContext(HTML5Backend)(DragDropContextWrapper);
